import { defineStore } from 'pinia'

export const useCommLogsStore = defineStore('comm-logs-store', {
    state: () => ({
        user: {},
        recipient: {},
        commLogs: [],
        commLog: {},
        commReasons: [],
        commStatuses: [],
        channels: [],
        error: null,
        loading: false
    }),
    actions: {
        setSender(sender, senderRoles, senderType) {
            this.user = sender
            this.user.roles = senderRoles
            this.user.type = senderType
        },
        setUpdater(updater, updaterRoles, updaterType) {
            this.user = updater
            this.user.roles = updaterRoles
            this.user.type = updaterType
        },
        setRecipient(recipient, recipientType) {
            this.recipient = recipient
            this.recipient.type = recipientType
        },
        setCommReasons(commReasons) {
            this.commReasons = JSON.parse(commReasons)
        },
        setCommStatuses(commStatuses) {
            this.commStatuses = JSON.parse(commStatuses)
        },
        setChannels(channels) {
            this.channels = JSON.parse(channels)
        },
        setCommLog(log) {
            this.commLog = log
        },
        async fetchCommLogs() {
            this.commLogs = []
            this.loading = true
            try {
                let _commLogs = await fetch('/api/comm-logs?recipient_type='+ this.recipient.type +'&recipient_id='+ this.recipient.id)
                    .then((response) => response.json())
                this.commLogs = _commLogs['data']
            } catch (error) {
                this.error = error
            }
        },
        async saveCommLog() {
            try {
                if (this.commLog.id) {
                    await axios.put('/api/comm-logs/'+ this.commLog.id, { commLog: this.commLog, updater: this.user, recipient: this.recipient })
                } else {
                    await axios.post('/api/comm-logs', { commLog: this.commLog, sender: this.user, recipient: this.recipient })
                }
            } catch (error) {
                this.error = error
            } finally {
                this.commLog = {}
                this.fetchCommLogs()
            }
        },
        async fetchChannels() {
            this.channels = []
            this.loading = true
            try {
                let _channels = await fetch('/api/channels?recipient_type='+ this.recipient.type +'&recipient_id='+ this.recipient.id)
                    .then((response) => response.json())
                let allChannels = _channels['data']
                let goodChannels = allChannels.filter(obj => obj.is_bad == false)
                for (let channel of goodChannels) {
                    if (channel.channel_type_id == 3) {
                        let jAddress = JSON.parse(channel.address)
                        let singleLineAddress = jAddress.street1
                        singleLineAddress = jAddress.street2 ? singleLineAddress + ', ' + jAddress.street2 : singleLineAddress
                        singleLineAddress = jAddress.city ? singleLineAddress + ', ' + jAddress.city : singleLineAddress
                        singleLineAddress = jAddress.zipcode ? singleLineAddress + ', ' + jAddress.zipcode : singleLineAddress
                        channel.address = singleLineAddress
                    }
                    this.channels.push(channel)
                }
            } catch (error) {
                this.error = error
            }
        },
        async deleteCommLog(commLog) {
            try {
                await axios.delete('/api/comm-logs/'+ commLog.id)
                    .then((response) => response.json())
            } catch (error) {
                this.error = error
            } finally {
                this.fetchCommLogs()
            }
        },
    },
})